export const GA_TRACKING_ID = process.env.NEXT_PUBLIC_GA_ID;
export const ADMIN_GA_TRACKING_ID = process.env.NEXT_PUBLIC_ADMIN_GA_ID;

// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
const sendPageViewEvent = (url, trackingId) => {
  window.gtag('config', trackingId, {
    page_path: url,
  });
};

export const gaPageview = (url) => {
  sendPageViewEvent(url, GA_TRACKING_ID);
  if (window.gaTrackingId) {
    sendPageViewEvent(url, window.gaTrackingId);
  }
};

// https://developers.google.com/analytics/devguides/collection/gtagjs/events
export const gaEvent = ({ action, category, label, value }) => {
  window.gtag('event', action, {
    event_category: category,
    event_label: label,
    value: value,
  });
};
